import { useMemo, useState } from 'react';
import type { ExcludedTeethMap } from '../../../../../../services/dmMonitoringControl';
import { sortTeeth } from './toothNumbering';

const NONE: readonly string[] = [];

function sameTeeth(a: readonly string[], b: readonly string[]): boolean {
    if (a.length !== b.length) return false;
    const sortedB = sortTeeth(b);
    return sortTeeth(a).every((tooth, index) => tooth === sortedB[index]);
}

// Edits stay local until Save; `changes` is what differs from DM, empty lists included so a
// cleared notification is sent too.
export function useExcludedTeethDraft(saved: ExcludedTeethMap) {
    const [edits, setEdits] = useState<ExcludedTeethMap>({});

    const teethFor = (reference: string): readonly string[] =>
        edits[reference] ?? saved[reference] ?? NONE;

    const setTeeth = (references: readonly string[], teeth: readonly string[]) =>
        setEdits((current) => ({
            ...current,
            ...Object.fromEntries(references.map((reference) => [reference, sortTeeth(teeth)]))
        }));

    const changes = useMemo(
        () =>
            Object.fromEntries(
                Object.entries(edits).filter(
                    ([reference, teeth]) => !sameTeeth(teeth, saved[reference] ?? NONE)
                )
            ),
        [edits, saved]
    );

    return { teethFor, setTeeth, changes };
}
